export enum RichEditorType {
    SIGNATURE = "signature",
    EMAIL_TEMPLATE = "email_template",
    REFERRAL = "referral",
    GIFT = "gift",
    REMINDER = "reminder",
    MAILER = "mailer",
}